module.exports = __webpack_public_path__ + "static/media/codigolivre-pesquisa.b8eed23e.png";